import { DrivingLicenseTypes, GenderTypes, JobTypes } from 'src/pages/Job/Job.types';
import { JOB_STATUS } from './JobStatus.enum';
import { Role } from './Role.type';
import { WorkerProfile } from './WorkerProfile.type';
import { PostSchedule } from './FacebookPost.type';

export interface InterviewQuestion {
  question: string;
  partDuration?: number;
  description?: string;
  points?: string[];
  conclusion?: string;
  numOfRetakes?: number;
  explanation?: string;
}

export interface JobWage {
  hourlyCommissionAmount: number;
  hourlyGrossAmount: number;
  hourlyNetAmount: number;
  hourlyPersonalTaxAmount: number;
  invoicedHourlyAmount: number;
  rake: number;
  tax: number;
  totalCommissionAmount: number;
  totalGrossAmount: number;
  totalInvoicedAmount: number;
  totalNetAmount: number;
  totalPersonalTaxAmount: number;
}

export interface Job {
  id: string;
  hourlyGrossWage: number;
  monthlyHours: number;
  startDate: Date;
  endDate: Date | null;
  status: JOB_STATUS;
  role: Role;
  createdAt: Date;
  updatedAt: Date;
  workers: WorkerProfile[];
  wage: JobWage;
  weeklyHours: number;
  jobType: JobTypes;
  timeSchedule?: string;
  workerCount: string;
  startNow: boolean;
  genderTypes?: GenderTypes[];
  hungarianSkillsNeeded?: boolean;
  documents?: string;
  extraSkills?: string;
  drivingLicense?: DrivingLicenseTypes;
  englishSkillsNeeded?: boolean;
  bonus?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  arriveInfo?: string;
  equipmentInfo?: string;
  recruitmentNeeded?: boolean;
  activeWorkersCount?: number;
  postSchedule: PostSchedule;
  interviewQuestions?: InterviewQuestion[] | null;
}

export enum JobApplicationStatus {
  Pending = 'pending',
  Sent = 'sent',
  Declined = 'declined',
  Accepted = 'accepted',
  Cancelled = 'cancelled',
}

export enum JobApplicationAction {
  ACCEPT = 'Accept',
  DECLINE = 'Decline',
}

export interface JobApplication {
  jobId: string;
  status: JobApplicationStatus;
  worker: WorkerProfile;
  id: string;
  isSuccess: boolean;
  message?: string;
}
